<template>
  <b-card
    no-body
    :style="`height: ${componentOptions.cardHeight ? componentOptions.cardHeight : '60vh'};`"
  >
    <b-card-header>
      <b-card-title>Citizenship</b-card-title>
    </b-card-header>

    <b-card-body>
      <b-overlay :show="isLoading">
        <!-- apex chart -->
        <vue-apex-charts
          type="donut"
          height="220"
          class="my-1"
          :options="citizenship.chartOptions"
          :series="citizenship.series"
        />

        <!-- chart info -->
        <div
          v-for="(data, key, index) in chartInfo"
          :key="key"
          class="d-flex justify-content-between"
          :class="index === Object.keys(chartInfo).length - 1 ? '' : 'mb-1'"
        >
          <div class="series-info d-flex align-items-center">
            <feather-icon
              icon="CircleIcon"
              size="16"
              :style="`color: ${data.color}`"
            />
            <span class="font-weight-bold text-capitalize ml-75">{{
              data.title
            }}</span>
          </div>

          <span>{{ data.value }}</span>
        </div>
      </b-overlay>
    </b-card-body>
  </b-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import { $themeColors } from '@themeConfig'

export default {
  components: {
    VueApexCharts,
  },
  props: ['componentOptions', 'reportData', 'section'],
  data() {
    return {
      isLoading: false,
      chartInfo: {
        singaporean: {
          value: 0,
          title: 'Singaporean',
          color: $themeColors.primary,
        },
        singaporean_pr: {
          value: 0,
          title: 'Singaporean PR',
          color: $themeColors.success,
        },
        other: {
          value: 0,
          title: 'Other',
          color: $themeColors.warning,
        },
      },
      citizenship: {
        series: [],
        chartOptions: {
          chart: {
            toolbar: {
              show: false,
            },
          },
          labels: ['Singaporean', 'Singaporean PR', 'Other'],
          colors: [
            $themeColors.primary,
            $themeColors.success,
            $themeColors.warning,
          ],
          dataLabels: {
            enabled: false,
          },
          legend: { show: false },
          comparedResult: [2, -3, 8],
          stroke: { width: 0 },
        },
      },
    }
  },
  watch: {
    reportData(newVal, oldVal) {
      this.updateData(newVal)
    },
  },
  mounted() {
    if (Object.keys(this.reportData).length > 0) {
      this.updateData(this.reportData)
    }
  },
  methods: {
    updateData(newVal) {
      const chartData = newVal.statistics.charts[this.section].citizenship_count
      this.citizenship = {
        series: [
          chartData.Singaporean,
          chartData['Singaporean PR'],
          chartData.Other,
        ],
        chartOptions: {
          chart: {
            toolbar: {
              show: false,
            },
          },
          labels: ['Singaporean', 'Singaporean PR', 'Other'],
          colors: [
            $themeColors.primary,
            $themeColors.success,
            $themeColors.warning,
          ],
          dataLabels: {
            enabled: false,
          },
          legend: { show: false },
          comparedResult: [2, -3, 8],
          stroke: { width: 0 },
        },
      }

      this.chartInfo = {
        singaporean: {
          value: chartData.Singaporean,
          title: 'Singaporean',
          color: $themeColors.primary,
        },
        singaporean_pr: {
          value: chartData['Singaporean PR'],
          title: 'Singaporean PR',
          color: $themeColors.success,
        },
        other: {
          value: chartData.Other,
          title: 'Other',
          color: $themeColors.warning,
        },
      }
    },
  },
}
</script>
